import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailDialogComponent } from './email-dialog.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    EmailDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule
  ]
})
export class EmailDialogModule { }
